export class DeleteConfirmationData {
  displayText: string;

  constructor(displayText: string) {
    this.displayText = displayText;
  }
};
